import React from "react";

import "./Hamburger.css";

const Hamburger = (props) => {
  return (
    <div>
      <input type="checkbox" className="checkbox" id="click" hidden></input>
      <label htmlFor="click" onClick={props.onClick}>
        <div className="mobile-menu">
          <div className="line line-1"></div>
          <div className="line line-2"></div>
          <div className="line line-3"></div>
        </div>
      </label>
    </div>
  );
};
export default Hamburger;
